import {
    SIM_INFO_REQUEST,
    SIM_INFO_RESULT,
} from 'Redux/actionTypes';

export const simInfoRequest = (data) => ({
    type: SIM_INFO_REQUEST,
    payload: data
})

export const simInfoResult = (result) => ({
    type: SIM_INFO_RESULT,
    payload: result
})